var _circle, _circle2, _line, _line2, _line3, _line4, _line5, _ellipse, _rect, _polygon, _polygon2, _circle3, _circle4, _circle5, _circle6, _circle7, _ellipse2, _ellipse3, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatNature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#e8f5e9",
    stroke: "#a5d6a7",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 22,
    r: 9,
    fill: "#f9d64f",
    stroke: "#c8a800",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 10,
    x2: 40,
    y2: 7,
    stroke: "#c8a800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 14,
    x2: 54,
    y2: 12,
    stroke: "#c8a800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 14,
    x2: 26,
    y2: 12,
    stroke: "#c8a800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 22,
    x2: 60,
    y2: 22,
    stroke: "#c8a800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 22,
    x2: 20,
    y2: 22,
    stroke: "#c8a800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 66,
    rx: 28,
    ry: 7,
    fill: "#8cc870",
    stroke: "#5a9a40",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46,
    width: 8,
    height: 20,
    rx: 3,
    fill: "#a06030",
    stroke: "#7a4820",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "40,18 56,46 24,46",
    fill: "#4aaa40",
    stroke: "#2a8020",
    strokeWidth: 1.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "40,24 54,48 26,48",
    fill: "#5abe50",
    stroke: "#2a8020",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 62,
    r: 3,
    fill: "#f9d64f",
    stroke: "#c8a800",
    strokeWidth: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 58,
    r: 2.5,
    fill: "#e84080"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 62,
    r: 2.5,
    fill: "#e84080"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 62,
    r: 2.5,
    fill: "#e84080"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 66,
    r: 2.5,
    fill: "#e84080"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 28,
    rx: 8,
    ry: 5,
    fill: "white",
    stroke: "#c0d8f0",
    strokeWidth: 1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 30,
    rx: 5,
    ry: 4,
    fill: "white",
    stroke: "#c0d8f0",
    strokeWidth: 1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 30,
    rx: 5,
    ry: 4,
    fill: "white",
    stroke: "#c0d8f0",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatNature);
export default __webpack_public_path__ + "static/media/cat-nature.d445c0f2fbdbd43507903b15487e6c49.svg";
export { ForwardRef as ReactComponent };